<template>
    <div class="home-search">
        <form action="/">
            <van-search v-model="value" :show-action="false" left-icon="" @click.prevent="$router.push({ path: '/Searching' })">
                <van-icon name="search" slot="right-icon" @click.prevent.stop="getSearchKeyword" />
            </van-search>
        </form>
        <van-swipe style="height: 24px;" :autoplay="1500" vertical :show-indicators="false" @change="getSearchIndex">
            <van-swipe-item v-for="(item, index) in SwipeSearchValue" :key="index" @click="$router.push({ path: '/Searching' })">{{ item }}</van-swipe-item>
        </van-swipe>
    </div>
</template>

<script>
export default {
    data() {
        return {
            value: null,
            SwipeSearchValue: null,
            index: 0
        };
    },
    methods: {
        getSwipeSearchValue() {
            this.axios.get("https://novel.kele8.cn/hot-books").then(response => {
                // window.console.log(response.data.hotWords);
                ({ hotWords: this.SwipeSearchValue } = response.data);
            });
        },
        getSearchIndex(index) {
            this.index = index;
        },

        getSearchKeyword() {
            // 传递到vuex的变量中

            this.$store.commit("setSearchKeyword", {
                value: this.SwipeSearchValue[this.index]
            });
            this.$router.push({
                path: "/search",
                query: {
                    keyword: this.SwipeSearchValue[this.index]
                }
            });
        }
    },
    created() {
        this.getSwipeSearchValue();
    }
};
</script>

<style lang="less">
.home-search {
    position: relative;
    form {
        .van-search {
            padding: 5px 10px;
        }
    }
    .van-swipe {
        width: 40%;
        position: absolute;
        top: 15px;
        left: 20px;
        color: #666;
        font-size: 14px;
        .van-swipe-item {
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 1;
            overflow: hidden;
        }
    }
}
</style>
